import { IntercomIcon } from "#components/ui/IntercomIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const intercomManifest: IntegrationManifest = {
    key: "intercom",
    displayName: "Intercom",
    nameKey: "channels.intercom",
    descriptionKey: "intercomDescription",
    trayDescriptionKey: "composerTrayDescriptions.intercom",
    cardDescriptionKey: "connectIntegration.descriptions.intercom",
    connectedContentKeys: ["intercomConversations"],
    brandColor: "#111111",
    iconUrl: IconAssets.Intercom,
    iconUrlAlt: IconAssets.IntercomAlt,
    glyph: IntercomIcon,
    channelType: "UserIntercomMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
